<template>
  <div class="ratings" ref="ratingView">
	<div style="text-align:center;">
		<div class="weui-msg__icon-area"><i class="weui-icon_msg weui-icon-download"></i></div>
		<div class="weui-msg__text-area">
			<h2 class="weui-msg__title">取货码取货</h2>
			<p class="weui-msg__desc">您可以在此处输入您从商户获得的 8 位数字组成的取货码</p>
		</div>
	</div>
    <div class="weui-cells weui-cells_form">
		<div class="weui-cell">
			<div class="weui-cell__hd"><label class="weui-label">取货码</label></div>
			<div class="weui-cell__bd">
				<input class="weui-input" v-model="PickupCode" pattern="[0-9]*" placeholder="请输入取货码" type="number" @keyup="checkNumber()" @change="checkNumber()">
			</div>
		</div>
	</div>
	<div class="weui-btn-area">
		<a v-show="butenShow == 'true'" class="weui-btn weui-btn_primary" href="javascript:" @click="checkCode()">确定</a>
	</div>
  <div style="text-align:center;">
		<div class="weui-msg__text-area">
			<h4 class="weui-msg__title">{{ msg }}</h4>
		</div>
	</div>
  </div>
</template>

<script>
import Split from '../../components/split/Split'
import Star from '../../components/star/Star'
import BScroll from 'better-scroll'
export default {
  name: 'PinckupCode',
  props:["machineId"],
  data () {
    return {
		PickupCode: undefined,
		butenShow: 'true',
		msg: '',
    }
  },
  methods: {
    selectTypeFn(type){
      this.selectType = type
    },
	checkNumber(){
		this.butenShow = 'true'
		if(this.PickupCode.length > 6){
			this.PickupCode = this.PickupCode.substring(0,6);
		}
	},
	checkCode(){
		if(this.PickupCode == undefined){
			this.showTips("请填写取货码");
			return
		}
		if(this.PickupCode.length < 6){
			alert('取货码不能少于6位')
			return
		}
		this.butenShow = 'false'
		const postData = { PickupCode: this.PickupCode, MachineId: this.machineId }
		console.log(postData)
		this.axios.post(   //请求方式
          "https://home.hrcc8.com/home/api/c/pinckupCodeOutput",  //接口地址
          postData
        )    //传递参数 
        .then((res) =>{
			this.showTips(res.data.msg);
			if(res.data.code == 20000){
				this.msg = res.data.msg
			}
        })
        .catch((error) => {
			this.showTips("非常抱歉，系统出现内部错误！"+error);
        })
	},
	showTips(info){
      //提示消息
      this.$emit('showTip',info)
    },
  },
  created() {
    //请求ratings
    this.axios.get('/api/ratings')
    .then((res)=>{
     
      })

  },
  components:{
    Split,
    Star
  }
}
</script>


<style scoped>
@import url('../../common/css/style.css');
@import url('../../common/css/weui.css');
@import url('../../common/css/weuix.css');
.ratings {
		position: absolute;
		left: 0;
		top:240px;
		bottom: 0;
		width: 100%;
		overflow: hidden; 
	}
	
	.ratings .ratings-wrapper .overview {
		padding: 20px 0 18px 0;
		display: flex;
	}
	
	.ratings .ratings-wrapper .overview .overview-left {
		flex: 1;
		padding-left: 26px;
	}
	
	.ratings .ratings-wrapper .overview .overview-left .comment-score {
		float: left;
		width: 48px;
		text-align: center;
		margin-right: 26px;
	}
	
	.ratings .ratings-wrapper .overview .overview-left .comment-score .score {
		font-size: 23px;
		font-weight: 800;
		color: #ffb000;
		margin-bottom: 9px;
    margin-top: 5px;
	}
	
	.ratings .ratings-wrapper .overview .overview-left .comment-score .text {
		font-size: 11px;
		color: #666666;
	}
	
	.ratings .ratings-wrapper .overview .overview-left .other-score {
		float: left;
		margin-top: 9px;
	}
	
	.ratings .ratings-wrapper .overview .overview-left .other-score .item {
		height: 23px;
	}
	
	.ratings .ratings-wrapper .overview .overview-left .other-score .item .text {
		font-size: 11px;
		color: #666666;
		margin-right: 11px;
		float: left;
	}
	
	.ratings .ratings-wrapper .overview .overview-left .other-score .item .star {
		float: left;
		margin-right: 11px;
	}
	
	.ratings .ratings-wrapper .overview .overview-left .other-score .item .score {
		font-size: 11px;
		color: #FFB000;
		float: left;
	}
	
	.ratings .ratings-wrapper .overview .overview-left .other-score .quality-score {
		margin-bottom: 14px;
	}
	
	.ratings .ratings-wrapper .overview .overview-right {
		flex: 0 0 100px;
		text-align: center;
		border-left: 1px solid #9D9D9D;
	}
	

	.ratings .ratings-wrapper .overview .overview-right .delivery-score .score {
		font-size: 19px;
		font-weight: 500;
		color: #999999;
		margin-bottom: 10px;
		margin-top: 8px;
	}
	
	.ratings .ratings-wrapper .overview .overview-right .delivery-score .text {
		font-size: 11px;
		color: #999999;
	}


  .ratings .ratings-wrapper .content {
		padding: 16px 16px 16px 16px;
    box-sizing: border-box
	}
	
	.ratings .ratings-wrapper .content .rating-select {
		width: 100%;
		box-sizing: border-box;
		font-size: 0;
		border: 1px solid #FFB000;
		border-right: 0;
		margin-bottom: 11px;
		border-radius: 3px;
	}
	
	.ratings .ratings-wrapper .content .rating-select .item {
		width: 33.3%;
		display: inline-block;
		height: 33px;
		line-height: 33px;
		font-size: 14px;
		text-align: center;
		border-right: 1px solid #FFB000;
		box-sizing: border-box;
		color: #FFB000;
	}

	
	.ratings .ratings-wrapper .content .rating-select .item:last-child img {
		height: 14px;
		vertical-align: middle;
	}
	
	.ratings .ratings-wrapper .content .rating-select .item.active {
		background: #FFB000;
		color: black;
	}
	

	
	.ratings .ratings-wrapper .content .labels-view .item {
		display: inline-block;
		height: 27px;
		line-height: 27px;
		padding: 0 10px;
		font-size: 12px;
		background: #F4F4F4;
		margin-right: 6px;
		margin-bottom: 6px;
		border-radius: 3px;
		color: #999999;
	}
	
	.ratings .ratings-wrapper .content .labels-view .item.highligh {
		color: #656565;
	}
   .ratings .ratings-wrapper .content .rating-list {
     padding: 0
   }
	
.ratings .ratings-wrapper .content .rating-list .comment-item {
	padding: 16px 16px 16px 0;
	border-bottom: 1px solid #F4F4F4;
	width: 100%;
	box-sizing: border-box;
	display: flex;
}

.ratings .ratings-wrapper .content .rating-list .comment-item .comment-header {
	flex: 0 0 35px;
	margin-right: 11px;
}

.ratings .ratings-wrapper .content .rating-list .comment-item .comment-header img {
	width: 35px;
	height: 35px;
	border-radius: 50%;
}

.ratings .ratings-wrapper .content .rating-list .comment-item .comment-main {
	flex: 1;
}

.ratings .ratings-wrapper .content .rating-list .comment-item .comment-main .user {
	width: 50%;
	float: left;
	font-size: 11px;
	color: #333333;
}

.ratings .ratings-wrapper .content .rating-list .comment-item .comment-main .time {
	width: 50%;
	float: right;
	text-align: right;
	font-size: 9px;
	color: #666666;
}

.ratings .ratings-wrapper .content .rating-list .comment-item .comment-main .star-wrapper {
	float: left;
	margin-top: 12px;
	margin-bottom: 15px;
	width: 100%;
}

.ratings .ratings-wrapper .content .rating-list .comment-item .comment-main .star-wrapper .text {
	color: #999999;
	font-size: 11px;
	float: left;
}

.ratings .ratings-wrapper .content .rating-list .comment-item .comment-main .star-wrapper .star {
	float: left;
	margin-left: 7px;
}

.ratings .ratings-wrapper .content .rating-list .comment-item .comment-main .c_content {
	font-size: 13px;
	line-height: 19px;
	float: left;
	width: 100%;
}

.ratings .ratings-wrapper .content .rating-list .comment-item .comment-main .c_content i {
	color: #576b95;
}

.ratings .ratings-wrapper .content .rating-list .comment-item .comment-main .img-wrapper {
	margin-top: 9px;
	float: left;
}

.ratings .ratings-wrapper .content .rating-list .comment-item .comment-main .img-wrapper img {
	width: 175px;
}

</style>


// WEBPACK FOOTER //
// src/components/pinkupCode/PinkupCode.vue